// 成绩格式化（前后端共用）

export function formatTime(ms) {
  if (ms === null || ms === undefined || Number.isNaN(ms)) return 'DNF';
  if (ms < 0) return '—';
  const totalMs = Math.round(ms);
  const minutes = Math.floor(totalMs / 60000);
  const seconds = Math.floor((totalMs % 60000) / 1000);
  const centis = Math.floor((totalMs % 1000) / 10);
  if (minutes > 0) {
    return `${minutes}:${String(seconds).padStart(2, '0')}.${String(centis).padStart(2, '0')}`;
  }
  return `${seconds}.${String(centis).padStart(2, '0')}`;
}

export function formatTimeMs(ms) {
  // 计时器实时显示：保留百分之一秒
  if (ms === null || ms === undefined) return '0.00';
  return formatTime(ms);
}

export function formatDate(isoOrMs, opts = {}) {
  const d = new Date(isoOrMs);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('zh-CN', opts);
}

export function formatDateTime(isoOrMs) {
  const d = new Date(isoOrMs);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString('zh-CN', { month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false });
}

export function timeAgo(isoOrMs) {
  const d = new Date(isoOrMs).getTime();
  const diff = Date.now() - d;
  if (diff < 60 * 1000) return '刚刚';
  if (diff < 3600 * 1000) return `${Math.floor(diff / 60000)} 分钟前`;
  if (diff < 24 * 3600 * 1000) return `${Math.floor(diff / 3600000)} 小时前`;
  if (diff < 7 * 24 * 3600 * 1000) return `${Math.floor(diff / 86400000)} 天前`;
  return formatDate(d);
}

export function penaltyLabel(p) {
  if (p === '+2') return '+2';
  if (p === 'dnf') return 'DNF';
  return '';
}
